export default __webpack_public_path__ + "static/media/daml-logo.a64916d9.png";